import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'div'>

/**
 * 単位を表示するラベル
 */
export const UnitLabel: FC<Props> = ({ className, children, ...props }) => {
  return (
    <span {...props} className={clsx(['ml-0.5 text-xs', className])}>
      {children}
    </span>
  )
}
